import { getAppEnv } from '../app-env';
import { readEnvVariable } from '../helpers';

export interface ISentryEnv {
  dsn: string;
  authToken: string;
  environment: string;
}

export function getSentryEnv(): ISentryEnv {
  const dsn = readEnvVariable('SENTRY_DSN');
  const authToken = readEnvVariable('SENTRY_AUTH_TOKEN');
  const environment = getAppEnv();

  return { dsn, authToken, environment };
}
